import { BaseApiModel } from './BaseApiModel';

export class ViolationContractCounter extends BaseApiModel {
  public contractId: string;
}
